import { SvgIcon } from '@material-ui/core'

export function CheckBoxIcon(props) {
  return (
    <SvgIcon {...props} width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect x="0.5" y="0.5" width="19" height="19" rx="5.5" fill="#F9F5FF" />
      <path
        d="M14.6666 6.5L8.24998 12.9167L5.33331 10"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="0.5"
        y="0.5"
        width="19"
        height="19"
        rx="5.5"
        fill="none"
        stroke="currentColor"
      />
    </SvgIcon>
  )
}
